export const resolveSelectedValue = (value, key = 'id') => {
  if (value == null || value === '') return null;
  if (typeof value === 'object') {
    const objectValue = value[key];
    return objectValue == null || objectValue === '' ? null : String(objectValue);
  }
  return String(value);
};

export const findBySelectedId = (items = [], selectedId, key = 'id') => (
  items.find((item) => String(item?.[key]) === String(selectedId))
);

export const buildIdFallback = (selectedId, key = 'id') => (
  selectedId ? { [key]: selectedId } : null
);

export const propagateSelectChange = ({ inputRef, onChange, value }) => {
  if (inputRef?.current?.onChange) inputRef.current.onChange(value);
  if (onChange) onChange(value);
};

export const propagateSelectBlur = (inputRef) => {
  if (inputRef?.current?.onBlur) inputRef.current.onBlur();
};

export const resolveFieldError = (meta = {}) => (
  (meta.touched || meta.submitError) && meta.error
);
